export enum LoginScenario {
  CHECKOUT = 'checkout',
  DEFAULT = 'default',
}
